import Vue from "vue";
import Vuex from "vuex";
import data from "@/assets/data/data.json";
import tooltip_data from "@/assets/data/tooltip_data.json";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    app_data: {},
    industry_list: [],
    selected_industry: "",
    results: [],
    selected_tooltip: {},
    isMobile: false
  },
  getters: {
    getAppData(state) {
      return state.app_data;
    },
    getIndustryList(state) {
      return state.industry_list;
    },
    getSelectedIndustry(state) {
      return state.selected_industry;
    },
    getResults(state) {
      return state.results;
    },
    getToolTip(state) {
      return state.selected_tooltip;
    },
    getIsMobile(state) {
      return state.isMobile;
    }
  },
  mutations: {
    SET_APP_DATA(state, data) {
      let industries = [];
      data.filter(el => {
        if (industries.indexOf(el.Industry) == -1) {
          industries.push(el.Industry);
        }
      });
      state.industry_list = industries.sort();
      state.app_data = data;
    },
    SET_SELECTED_INDUSTRY(state, val) {
      state.selected_industry = val;
    },
    GET_RESULTS(state, industry) {
      let temp_results = [];
      data.filter(el => {
        if (el.Industry == industry) {
          temp_results.push(el);
        }
      });
      state.results = temp_results.sort(this.compareResults);
    },
    SET_TOOLTIP_DATA(state, keepType) {
      tooltip_data.filter(el => {
        if (el.name === keepType) {
          state.selected_tooltip = el;
        }
      });
    },
    SET_IS_MOBILE(state, isMobile) {
      state.isMobile = isMobile;
    }
  },
  actions: {
    async fetchData({ commit }) {
      commit("SET_APP_DATA", data);
    },
    setIndustry({ commit }, value) {
      commit("SET_SELECTED_INDUSTRY", value);
    },
    getResults({ commit }, industry) {
      commit("GET_RESULTS", industry);
    },
    setTooltip({ commit }, keepType) {
      commit("SET_TOOLTIP_DATA", keepType);
    },
    setIsMobile({ commit }, isMobile) {
      commit("SET_IS_MOBILE", isMobile);
    },
    compareResults(a, b) {
      return a["Percentage of Industry Total"] >
        b["Percentage of Industry Total"]
        ? 1
        : b["Percentage of Industry Total"] > a["Percentage of Industry Total"]
        ? -1
        : 0;
    }
  }
});
